import { Component, EventEmitter, Input, OnInit, AfterViewInit, Output } from '@angular/core';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsFormModel } from 'src/app/models/widgets/widgets-form.model';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { CdkDrag, CdkDragDrop } from '@angular/cdk/drag-drop';
import { WidgetsContainerComponentAbstract } from 'src/app/abstract/widgets/widgets-container-component.abstract';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { CommandService } from 'src/app/services/command/command.service';
import { Logger } from 'src/app/core/logger';
import { WidgetsMetadataService } from 'src/app/services/widgets/widgets-metadata.service';
import { UserService } from 'src/app/core/user.service';
import { CommandResequenceSectionsService } from 'src/app/services/command/command-resequence-sections.service';
import { CommandResequenceQuestionsService } from 'src/app/services/command/command-resequence-questions.service';
import { WidgetsSelectionService } from 'src/app/services/widgets/widgets-selection.service';
import { Config } from 'src/app/config';

@Component({
  selector: 'app-widgets-form',
  templateUrl: './widgets-form.component.html',
  styleUrls: ['./widgets-form.component.scss']
})
export class WidgetsFormComponent extends WidgetsContainerComponentAbstract implements OnInit, AfterViewInit {
  @Input() data: WidgetsFormModel = new WidgetsFormModel();
  @Input() dropListIds: string[] = [];
  @Output() dropListIdAdded: EventEmitter<string> = new EventEmitter<string>();

  public isAdmin: boolean = true;

  constructor(public widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,
    private userService: UserService,
    private widgetsMetadataService: WidgetsMetadataService,
    private commandService: CommandService,
    private commandResequenceSections: CommandResequenceSectionsService,
    private commandResequenceQuestions: CommandResequenceQuestionsService,
    private logger: Logger) {
    super();
  }

  ngOnInit(): void {
    this.isAdmin = this.userService.isAdmin();
  }

  ngAfterViewInit(): void {
    // If Form is born seleted, directly show metadata on metadata area
    if (this.data.isSelected) {
      this.widgetsMetadataService.showMetadata(this.data);
    }
  }

  isPristine(): boolean {
    if (!this.widgetsService.isPristineActive) {
      return true;
    }
    return this.widgetsService.isPristine();
  }

  resetPristine(): void {
    this.widgetsService.resetPristine();
  }

  onWidgetDroppedToCanvas(event: CdkDragDrop<WidgetsAbstract[], WidgetsAbstract[], any>): WidgetsAbstract {
    // TODO: ROWS, SECTIONS, QUESTIONS and TEXT are instantiated here. Future: Command Pattern for Undo/Redo
    const form =  this.commandService.execute(this.data, event.item.data);
    this.commandService.prepareForUndo();
    return form;
  }


  isDroppableWidget(item: CdkDrag<WidgetsAbstract>) {
    // Constraints: Sections and Rows are allowed under a FORM. Questions will auto-create Sections
    if (item.data.widgetType === WidgetsTypeEnum.SECTION || item.data.widgetType === WidgetsTypeEnum.ROW) {
        return true;
    } else if (item.data.widgetType === WidgetsTypeEnum.QUESTION) {
      if (Config.FEATURES.get('isQuestionToFormDropEnabled')) {
        if (item.data.parentId) {
          // Can't move existing questions directly into the form element
          return false;
        } else {
          // Only NEW questions can be created into the form element.
          // A section will be created before
          return true;
        }
      }
    }
    /* eslint-enable no-fallthrough */
    return false;
  }

  /**
   * @deprecated Use WidgetsFormModel.cloneFrom instead
   * @param _widget
   */
  clone(_widget: any): WidgetsAbstract {
    throw new Error('Method not implemented.');
  }

  onWidgetsReordered(culprits: WidgetsAbstract[]) {
    this.commandResequenceSections.executeAsync(this.widgetsService.getLayoutRoot(), this.widgetsService.getLayoutRoot())
      .then((numSections) => {
        // this.logger.log("onResequence Resequenced " + numSections + " sections.");

        // Resequence Questions
        this.commandResequenceQuestions.executeAsync(this.widgetsService.getLayoutRoot(), undefined)
          .then((numQuestions) => {
            // this.logger.log("onResequence Resequenced " + numQuestions + " questions.");
          })
          .catch((error) => {
            // this.logger.warn("onResequence Questions Error " + error);
          });
      })
      .catch((error) => {
        this.logger.warn("onResequence Sections Error " + error);
      });
  }

  getFormTitle() {
    if (this.data && this.data.serviceCode && this.data.name) {
      return `${this.data.serviceCode} - ${this.data.name}`;
    } else if (this.data && this.data.name) {
      return this.data.name;
    } else {
      return 'Untitled Form';
    }
  }

  onSelect() {
    this.selectionService.toggleSelection(this.data);
  }

  onSectionCollapseAll(): void {
    this.widgetsService.collapseAll();
  }

  onSectionExpandAll(): void {
    this.widgetsService.expandAll();
  }

  isDeveloper(): boolean{
    return this.userService.isDeveloperUser() && Config.GLOBALS.isQuestionDroppingAreaEnabled;
  }
}
